<template>
  <div>
    <div v-if="teamOfTheDayMembers && teamOfTheDayMembers.length > 0">
      <div class="card-sakali field px-1 align-text-bottom">
        <div class="field-lines py-1">
          <div v-for="sp in strategicPositions" :key="sp"
               class="d-flex my-1 justify-content-around">
            <div v-for="member in playersInStrategicPosition(sp)"
                 :key="member.player.id"
                 class="text-center py-1 text-light text-nowrap text-truncate shadow-font">
              <sakali-player-avatar :player="member.player" size="32"/>
              <br/>
              <sakali-team-emblem
                  :emblem-id="member.player.team.emblemId"
                  size="17"
                  :shadow="false"/>
              {{ member.player.surName }}
              <span v-if="member.nominations > 1"
                    class="d-none d-md-inline"
                    style="font-size: 0.7em;">
                ({{ member.nominations }})
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-center text-secondary">Wird demnächst veröffentlicht.</div>
  </div>
</template>

<script>
import PlayerAvatar from "@/components/PlayerAvatar";
import TeamEmblem from "@/components/global/TeamEmblem";

export default {
  props: {
    roundId: Number
  },
  data() {
    return {
      teamOfTheDayMembers: null,
      strategicPositions: [...this.$store.getters.configuration.strategicPositions].reverse()
    }
  },
  methods: {
    loadTeamOfTheDay() {
      this.$api.get(`/totd/${this.roundId}`).then(response => {
        this.teamOfTheDayMembers = response.data
      }).catch(error => this.handleErrorAction(error))
    },
    playersInStrategicPosition(sp) {
      return this.teamOfTheDayMembers.filter(m => m.player.preferredStrategicPosition === sp)
    }
  },
  watch: {
    roundId() {
      if (this.roundId)
        this.loadTeamOfTheDay()
    }
  },
  mounted() {
    this.loadTeamOfTheDay()
  },
  components: {
    sakaliPlayerAvatar: PlayerAvatar,
    sakaliTeamEmblem: TeamEmblem
  }
}
</script>

<style>
.field {
  background-image: url('/img/gras.jpg');
}

.field-lines {
  background: url('/img/field-lines-up.gif') no-repeat;
  background-size: 100% 100%;
}

.shadow-font {
  text-shadow: -1px -1px 0 #000,
  1px -1px 0 #000,
  -1px 1px 0 #000,
  1px 1px 0 #000;
}
</style>